// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"61abb871","602":"61abb871"}[chunkId] + ".chunk.css";
};